"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBaseSegment = createBaseSegment;
function createBaseSegment(segments) {
    const { first, second, third, embed } = segments;
    if (embed) {
        if (third) {
            return `embed/${embed}/${first}/${second}/${third}`;
        }
        if (second) {
            return `embed/${embed}/${first}/${second}`;
        }
        return `embed/${embed}/${first}`;
    }
    if (third) {
        return `${first}/${second}/${third}`;
    }
    if (second) {
        return `${first}/${second}`;
    }
    return first;
}
